import { MAX_LENGTH_50 } from 'Models/Constants';
import * as yup from 'yup';

export const CreateAmenityCategorySchema = yup.object({
    name: yup.string().required('Errors.required').max(MAX_LENGTH_50, 'Errors.length_50'),
});
